import { dichVuHoSoApi } from "../../../api/dich-vu/dichVuHoSoApi";
import { hoaDonDienTuApi } from "../../../api/hoa-don/hoaDonDienTuApi";
import { IPhatHanhDichVuMultipleRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IDichVuHoSo } from "../../../model/respone/dich-vu/IDichVuHoSo";
import { IDichVuHoSoVm } from "../../../model/respone/dich-vu/IDichVuHoSoVm";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDichVuHoSoActionIds,
  IDichVuHoSoActionTypes,
} from "../../action-types/dich-vu/IDichVuHoSoActions";
import { rootActions } from "../../actions/rootActions";

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

export function* dichVuHoSoSaga(): any {
  yield takeLatest(eDichVuHoSoActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDichVuHoSoActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDichVuHoSoActionIds.DELETE_START, deleteWorker);
  yield takeEvery(eDichVuHoSoActionIds.IMPORT_START, importWorker);
  yield takeEvery(eDichVuHoSoActionIds.DELETE_MANY_START, deleteManyWorker);
}

function* loadWorker(action: IDichVuHoSoActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuHoSoApi.SelectVmByDichVu,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.hoSo.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.dichVu.hoSo.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDichVuHoSoActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDichVuHoSo;
  if (payload.id > 0) {
    res = yield call(dichVuHoSoApi.Update, payload);
  } else {
    res = yield call(dichVuHoSoApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.dichVu.hoSo.SAVE_SUCCESS(res.data));
    } else {
      yield put(rootActions.dichVu.hoSo.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* deleteManyWorker(action: IDichVuHoSoActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuHoSoApi.Deletes,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.hoSo.DELETE_MANY_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.dichVu.hoSo.DELETE_MANY_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* deleteWorker(action: IDichVuHoSoActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuHoSoApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.hoSo.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.dichVu.hoSo.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* importWorker(action: IDichVuHoSoActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuHoSoApi.Import,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.hoSo.IMPORT_SUCCESS(undefined));
  } else {
    yield put(rootActions.dichVu.hoSo.IMPORT_ERROR(res.message ?? "Có lỗi"));
  }
}
